import Pagination from './Pagination';
export { PaginationConfig, PaginationProps } from './Pagination';
export default Pagination;
